import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="w-full flex justify-center items-center py-12 opacity-50" data-id="element-155">
      <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent w-1/3" data-id="element-156"></div>
      <div className="w-2 h-2 rotate-45 bg-gold mx-4" data-id="element-157"></div>
      <div className="h-px bg-gradient-to-r from-transparent via-gold to-transparent w-1/3" data-id="element-158"></div>
    </div>;
}